import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import FrontendReleaseCheckUpdates from 'components/FrontendReleaseCheckUpdates';
import StaticResourceRefreshPrompt from 'components/StaticResourceRefreshPrompt';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <RouterProvider router={router} />
      <FrontendReleaseCheckUpdates />
      <StaticResourceRefreshPrompt />
    </ThemeCustomization>
  );
}
